import { render, staticRenderFns } from "./MenuDesktopComponent.vue?vue&type=template&id=63d4a368"
import script from "./MenuDesktopComponent.vue?vue&type=script&lang=js"
export * from "./MenuDesktopComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports